import QueueLink from './QueueLink';
export default QueueLink;
